import { render, staticRenderFns } from "./ColorsGroup.vue?vue&type=template&id=48f39bd5&"
import script from "./ColorsGroup.vue?vue&type=script&lang=js&"
export * from "./ColorsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports